export enum Paths {
  Market = '/',
  Support = '/support',
  Staking = '/staking',
}
